import { Component, input } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'lfw-toolbar-text',
  templateUrl: './app-toolbar-text.component.html',
  styleUrl: './app-toolbar-text.component.scss',
  imports: [MatToolbarModule]
})
export class AppToolbarTextComponent {
  text = input.required<string>();
}
